import React, { Component, Fragment } from 'react';
import { compose, setDisplayName } from 'recompose';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  injectIntl,
} from 'components';

const styles = () => ({
  disabledButton: { background: 'gray !important' },
  dropDownItem: { padding: '0px 10px' },
});



class FarmPractices extends Component {

  constructor(props) {
    super(props);

    this.state = {
      checked1: false
    };
  }

  handleChange = (event) => {
    this.setState({ test2: !this.state.checked1 });
  };

  render() {
    return (
      <div>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Combustion System Improvement (CPS 372)</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="checked1" />}
                  label="Improved Farm Equipment Fuel Efficiency"
                />
              </FormGroup>
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Conservation Crop Rotation (CPS 328)</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Decrease Fallow Frequency or Add Perennial Crops to Rotations"
                />
              </FormGroup>
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Cover Crop (CPS 340)</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Add Legume Seasonal Cover Crop to Irrigated Cropland"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Add Legume Seasonal Cover Crop to Non-Irrigated Cropland"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Add Non-Legume Seasonal Cover Crop to Irrigated Cropland"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Add Non-Legume Seasonal Cover Crop to Non-Irrigated Cropland"
                />
              </FormGroup>
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Mulching (CPS 484)</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Add Mulch to Croplands"
                />
              </FormGroup>
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Multiple Conservation Practices</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 10) (CPS 590) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 10) (CPS 590) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 15) (CPS 590) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 15) (CPS 590) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 20) (CPS 590) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 20) (CPS 590) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 25) (CPS 590) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 25) (CPS 590) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Legume Seasonal Cover Crop (CPS 340) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Legume Seasonal Cover Crop (CPS 340) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Non-Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 10) (CPS 590) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Non-Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 10) (CPS 590) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Non-Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 15) (CPS 590) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Non-Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 15) (CPS 590) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Non-Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 20) (CPS 590) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Non-Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 20) (CPS 590) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Non-Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 25) (CPS 590) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Non-Legume Seasonal Cover Crop (CPS 340) + Replace Synthetic N Fertilizer with Compost (CN ratio 25) (CPS 590) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Non-Legume Seasonal Cover Crop (CPS 340) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Add Non-Legume Seasonal Cover Crop (CPS 340) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Synthetic N Fertilizer Reductions of 15% (CPS 590) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till (CPS 329) + Synthetic N Fertilizer Reductions of 15% (CPS 590) on Non-Irrigated Croplands"
                />
              </FormGroup>
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Nutrient Management (CPS 590)</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Improved N Fertilizer Management on Irrigated Croplands - Reduce Fertilizer Application Rate by 15%"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Improved N Fertilizer Management on Irrigated Croplands - Use of Nitrification Inhibitors"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Improved N Fertilizer Management on Irrigated Croplands - Use of Slow Release Fertilizers"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Improved N Fertilizer Management on Non-Irrigated Croplands - Reduce Fertilizer Application Rate by 15%"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Improved N Fertilizer Management on Non-Irrigated Croplands - Use of Nitrification Inhibitors"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Improved N Fertilizer Management on Non-Irrigated Croplands - Use of Slow Release Fertilizers"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Beef Feedlot Manure on Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Beef Feedlot Manure on Non-Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Chicken Broiler Manure on Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Chicken Broiler Manure on Non-Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Chicken Layer Manure on Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Chicken Layer Manure on Non-Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Compost (CN ratio 10) on Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Compost (CN ratio 10) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Compost (CN ratio 15) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Compost (CN ratio 15) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Compost (CN ratio 20) on Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Compost (CN ratio 20) on Non-Irrigated Croplands"
                />
                 <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Compost (CN ratio 25) on Non-Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Dairy Manure on Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Other Manure on Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Other Manure on Non-Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Sheep Manure on Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Sheep Manure on Non-Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Swine Manure on Irrigated Croplands"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Replace Synthetic N Fertilizer with Swine Manure on Non-Irrigated Croplands"
                />
              </FormGroup>
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Residue and Tillage Management - No-Till (CPS 329)</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till on Irrigated Cropland"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to No Till or Strip Till on Non-Irrigated Cropland"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Reduced Till to No Till or Strip Till on Irrigated Cropland"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Reduced Till to No Till or Strip Till on Non-Irrigated Cropland"
                />
              </FormGroup>
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography> Residue and Tillage Management - Reduced Till (CPS 345)</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to Reduced Till on Irrigated Cropland"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Intensive Till to Reduced Till on Non-Irrigated Cropland"
                />
              </FormGroup>
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Stripcropping (CPS 585)</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Add Perennial Cover Grown in Strips with Irrigated Annual Crops"
                />
                <FormControlLabel
                  control={<Checkbox checked={this.state.checked} onChange={this.handleChange} value="gilad" />}
                  label="Add Perennial Cover Grown in Strips with Non-Irrigated Annual"
                />
              </FormGroup>
            </FormControl>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      
      </div>
    );
  }
}

export default compose(
  setDisplayName('FarmPractices'),
  withStyles(styles),
  injectIntl,
)(FarmPractices);
